<script setup lang="ts">
import type { Elemental, ViewSettings } from '~~/src/types/elemental'
import { CONTAINER_MAX_WIDTH } from '~~/src/layouts/default.vue'
import Card from '~/components/ElementalFeed/Card/index.vue'

interface IProps {
  data?: Elemental[]
  cardOptions: ViewSettings
  adsPositions?: number[]
}

const props = defineProps<IProps>()
defineOptions({
  name: 'ElementalGrid',
})
const { data, adsPositions } = toRefs(props)
const containerRef = ref()
</script>

<template>
  <section
    ref="containerRef"
    class="elemental-feed-container relative z-1 justify-center w-full mx-auto p-0 px-4 md:px-6 lg:px-8 pb-10"
    :style="{ maxWidth: `${CONTAINER_MAX_WIDTH}px` }"
  >
    <div
      class="elemental-feed-container__grid grid"
    >
      <div v-for="(item, index) in data" :key="index">
        <template v-if="adsPositions?.includes(index)">
          <AppPubCard :key="index">
            <template #fallback>
              <Card v-if="item" :key="index" :elemental="item" />
            </template>
          </AppPubCard>
        </template>
        <template v-else-if="item">
          <Card v-if="item" :key="index" :elemental="item" />
        </template>
      </div>
    </div>
  </section>
</template>

<style lang="scss">
.masonry-item {
  z-index: 1;
}
.masonry-item:hover {
  z-index: 2;
}

.elemental-feed-container {
  container-type: inline-size;
}

@container (max-width: 768px) {
  @apply flex-col;

  .elemental-feed-container__grid {
    @apply grid-cols-2 gap-3;
  }
}

@container (min-width: 769px) and (max-width: 1024px) {
  @apply flex-row;

  .elemental-feed-container__grid {
    @apply grid-cols-3 gap-3;
  }
}

@container (min-width: 1025px) {
  .elemental-feed-container__grid {
    @apply grid-cols-4 gap-10;
  }
}
</style>
